<div class="form-container" *ngIf="!isLoadingInitialData">
  <div class="form-header">
    <h1>{{ 'project_step_solutions_title' | translate }}</h1>
  </div>

  <div class="solutions">
    <div *ngIf="!currentItem.solutions || currentItem.solutions.length === 0" class="no-solutions-container">
      <div class="no-solutions-content">
        <p class="no-solutions-message">{{ 'project_solutions_no_solutions' | translate }}</p>
        <button mat-raised-button class="create-solution-btn" (click)="addSolution(currentItem.id)">
          <mat-icon>add</mat-icon>
          <span>{{ 'project_solutions_create_solution' | translate }}</span>
        </button>
      </div>
    </div>
    <div *ngIf="currentItem.solutions && currentItem.solutions.length > 0">
      <div class="title">
        <div class="title-left">
          <h3>{{ 'project_solutions_title' | translate }}</h3>
          <div class="btn-add ms-3">
            <button mat-mini-fab (click)="addSolution(currentItem.id)">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>
      </div>
      <div>
        <mat-tab-group [@.disabled]="true" class="row" [selectedIndex]="selected.value" (selectedIndexChange)="selected.setValue($event); changeTotalToShow()" animationDuration="0ms">
          <mat-tab *ngFor="let solution of currentItem.solutions; let index = index; trackBy: trackByIndexFn">
            <ng-template mat-tab-label>
              <div class="tab-label-container">
                <span [matTooltip]="solution.displayName || ''" [matTooltipDisabled]="(solution.displayName?.length || 0) <= 37">{{
                  (solution.displayName?.length || 0) > 37 ? (solution.displayName | slice: 0 : 37) + '…' : solution.displayName
                }}</span>
                <button mat-icon-button [matMenuTriggerFor]="solutionMenu" class="tab-menu-button" (click)="$event.stopPropagation()">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #solutionMenu="matMenu">
                  <button mat-menu-item (click)="onDuplicateSolution(solution?.id)">
                    <mat-icon>content_copy</mat-icon>
                    <span>{{ 'common_btn_duplicate' | translate }}</span>
                  </button>
                  <button mat-menu-item (click)="editSolution(solution)">
                    <mat-icon>create</mat-icon>
                    <span>{{ 'common_btn_edit' | translate }}</span>
                  </button>
                  <button mat-menu-item (click)="onDeleteSolution(index, solution?.id)">
                    <mat-icon>delete_outline</mat-icon>
                    <span>{{ 'common_btn_delete' | translate }}</span>
                  </button>
                </mat-menu>
              </div>
            </ng-template>
            <div class="panel-solution">
              <div *ngIf="showIncompleteProductsWarning" class="incomplete-products-warning">
                <div class="warning-content">
                  <div class="warning-text">
                    <mat-icon class="warning-icon">info</mat-icon>
                    <span>{{ 'project_solutions_incomplete_warning' | translate }}</span>
                  </div>
                  <button mat-icon-button (click)="hideIncompleteProductsWarning()" class="close-button">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
                <div class="incomplete-products-list">
                  <div *ngFor="let product of incompleteProductsList" class="incomplete-product-item">
                    {{ product }}
                  </div>
                </div>
              </div>
            </div>

            <form [formGroup]="solutionForm" class="form-content">
              <div class="form-section">
                <div class="form-row">
                  <mat-form-field appearance="outline" style="flex: 1">
                    <mat-label>{{ 'project_solutions_tender_call' | translate }}</mat-label>
                    <input matInput formControlName="callForTendersDisplayName" maxlength="100" [readonly]="isFromCallForTenders" [placeholder]="'project_solutions_tender_placeholder' | translate" />
                    <mat-hint align="end">{{ solutionForm.value.callForTendersDisplayName?.length || 0 }} / 100</mat-hint>
                  </mat-form-field>
                </div>
                <div class="form-row">
                  <mat-form-field appearance="outline" style="flex: 1">
                    <mat-label>{{ 'project_solutions_comment' | translate }}</mat-label>
                    <textarea matInput formControlName="description" rows="3" maxlength="512" [placeholder]="'project_solutions_comment_placeholder' | translate"></textarea>
                    <mat-hint align="end">{{ solutionForm.value.description?.length || 0 }} / 512</mat-hint>
                  </mat-form-field>
                </div>
              </div>

              <div class="form-section preservation-section" *ngIf="form?.value?.useWaterAndBiodeversityIndicators">
                <mat-accordion hideToggle>
                  <mat-expansion-panel [expanded]="true">
                    <mat-expansion-panel-header #preservationPanel>
                      <mat-panel-title>
                        <div class="preservation-header">
                          <mat-icon class="preservation-icon">eco</mat-icon>
                          <span class="preservation-title">{{ 'project_solutions_preservation_title' | translate }}</span>
                          <mat-icon class="preservation-chevron">
                            {{ preservationPanel._isExpanded() ? 'expand_less' : 'expand_more' }}
                          </mat-icon>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="form-row">
                      <div class="modern-upload-field">
                        <mat-form-field appearance="outline" style="flex: 1">
                          <mat-label>{{ 'project_solutions_preservation_water' | translate }} *</mat-label>
                          <mat-select formControlName="waterIndicator" panelClass="select-long-text">
                            <mat-option *ngFor="let w of waterList" [value]="w?.waterIndicator"> {{ w?.waterIndicator }} - {{ w?.displayName }} </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <div class="modern-file-upload" *ngIf="solutionForm.get('waterIndicator')?.value">
                          <input id="singleFile" #waterdescription type="file" class="file-input" accept="application/pdf" (change)="uploadBiodervisityFile(solution, waterdescription.files, 'w')" #fileWaterInput />
                          <div class="upload-area" (click)="fileWaterInput.click()" *ngIf="!solution.waterFileName">
                            <mat-icon class="upload-icon">cloud_upload</mat-icon>
                            <span class="upload-text">{{ 'project_solutions_add_file' | translate }}</span>
                          </div>
                          <div *ngIf="solution.waterFileName" class="file-preview">
                            <mat-icon class="file-icon">description</mat-icon>
                            <span class="file-name">{{ solution.waterFileName }}</span>
                            <button mat-icon-button class="remove-btn" (click)="deleteFileBiodiversity(solution, 'w')">
                              <mat-icon>close</mat-icon>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="modern-upload-field">
                        <mat-form-field appearance="outline" style="flex: 1">
                          <mat-label>{{ 'project_solutions_preservation_biodiversity' | translate }} *</mat-label>
                          <mat-select formControlName="biodiversityIndicator" panelClass="select-long-text">
                            <mat-option *ngFor="let b of biodiversityList" [value]="b?.biodiversityIndicator"> {{ b?.biodiversityIndicator }} - {{ b?.displayName }} </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <div class="modern-file-upload" *ngIf="solutionForm.get('biodiversityIndicator')?.value">
                          <input id="singleFileBioDiversity" #biodescription type="file" class="file-input" accept="application/pdf" (change)="uploadBiodervisityFile(solution, biodescription.files, 'b')" #fileBioInput />
                          <div class="upload-area" (click)="fileBioInput.click()" *ngIf="!solution.bioFileName">
                            <mat-icon class="upload-icon">cloud_upload</mat-icon>
                            <span class="upload-text">{{ 'project_solutions_add_file' | translate }}</span>
                          </div>
                          <div *ngIf="solution.bioFileName" class="file-preview">
                            <mat-icon class="file-icon">description</mat-icon>
                            <span class="file-name">{{ solution.bioFileName }}</span>
                            <button mat-icon-button class="remove-btn" (click)="deleteFileBiodiversity(solution, 'b')">
                              <mat-icon>close</mat-icon>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
            </form>

            <div *ngIf="!solution?.operations || (solution?.operations?.length ?? 0) === 0" class="no-operations-container">
              <div class="no-operations-content">
                <p class="no-operations-message">{{ 'project_solutions_no_operations' | translate }}</p>
                <button mat-raised-button class="create-operation-btn" (click)="addOperation(solution)">
                  <mat-icon>add</mat-icon>
                  <span>{{ 'project_solutions_create_operation' | translate }}</span>
                </button>
              </div>
            </div>
            <div *ngIf="(solution?.operations?.length ?? 0) > 0">
              <div class="inspection-header-info" *ngIf="indicators && indicators.length > 0 && indicators[indexEnergyToShow]">
                <div class="indicator-selector">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'synthese_col_indicator' | translate }}</mat-label>
                    <mat-select [(value)]="indexEnergyToShow" (selectionChange)="changeTotalToShow()">
                      <mat-option *ngFor="let indicator of indicators; let i = index" [value]="i"> {{ indicator.displayName | localizedLabel: 'indicator' : indicator.code }} ({{ indicator.workUnityDisplayShortName }}) </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="total-display">
                  {{ 'project_total' | translate }} {{ indicators[indexEnergyToShow].displayName | localizedLabel: 'indicator' : indicators[indexEnergyToShow].code }} =
                  <strong>{{ getFormattedTotalCost() }} {{ indicators[indexEnergyToShow].workUnityDisplayShortName }}</strong>
                </div>
              </div>
              <div class="title title-margin-top">
                <div class="title-left">
                  <h3>{{ 'project_solutions_operations_title' | translate }}</h3>
                  <div class="btn-add ms-3">
                    <button mat-mini-fab (click)="addOperation(solution)">
                      <mat-icon>add</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
              <div class="list-operation">
                <mat-accordion multi hideToggle cdkDropList (cdkDropListDropped)="onOperationDrop($event, solution)">
                  <mat-expansion-panel #panelRef *ngFor="let operation of solution?.operations; let indexOperation = index" cdkDrag>
                    <div *cdkDragPreview class="operation-drag-preview">
                      <mat-icon>drag_indicator</mat-icon>
                      <span>{{ operation?.displayName }}</span>
                    </div>
                    <div *cdkDragPlaceholder class="operation-drag-placeholder"></div>
                    <mat-expansion-panel-header
                      #panelOperation
                      (click)="panelOperation._toggle()"
                      class="item-operation"
                      cdkDragHandle
                      style="cursor: move"
                      [matTooltip]="(operation?.displayName?.length || 0) > 37 ? operation?.displayName : ('project_result_drag_reorder' | translate)">
                      <mat-panel-title>
                        <div class="modern-operation-header">
                          <div class="operation-main-content">
                            <div (click)="panelOperation._toggle()" class="operation-toggle-section">
                              <mat-icon class="expand-icon">
                                {{ panelOperation._isExpanded() ? 'expand_more' : 'chevron_right' }}
                              </mat-icon>
                              <div class="operation-info">
                                <span class="operation-name">{{ operation?.displayName }}</span>
                                <mat-icon class="error-indicator" *ngIf="operation.hasError" [matTooltip]="'project_solutions_error_detected' | translate"> warning </mat-icon>
                              </div>
                            </div>

                            <div class="operation-metrics">
                              <div class="total-value" *ngIf="operation?.detailedOperation?.ceuValues && indicators && indicators[indexEnergyToShow] && indicators[indexEnergyToShow].code !== 'CO'; else COOperation">
                                <span class="metric-label">{{ 'project_solutions_total' | translate }}</span>
                                <span class="metric-value">{{ labelI18n.exponential(getValue(operation), 2) }}</span>
                                <span class="metric-unit">{{ indicators[indexEnergyToShow].workUnityDisplayShortName }}</span>
                              </div>
                              <ng-template #COOperation>
                                <div class="total-value" *ngIf="operation?.detailedOperation?.ceuValues && indicators && indicators[indexEnergyToShow]">
                                  <span class="metric-label">{{ 'project_solutions_total' | translate }}</span>
                                  <span class="metric-value">{{ getValue(operation) | localizedNumber: '1.2-2' }}</span>
                                  <span class="metric-unit">{{ indicators[indexEnergyToShow].workUnityDisplayShortName }}</span>
                                </div>
                              </ng-template>
                            </div>
                          </div>

                          <div class="operation-actions">
                            <div class="action-group main-actions">
                              <button mat-icon-button (click)="copyOperation(operation, currentItem.id)" [matTooltip]="'project_operation_tooltip_copy_external' | translate" class="action-btn copy-external">
                                <mat-icon>share</mat-icon>
                              </button>
                              <button mat-icon-button (click)="onDuplicateOperation(operation?.id)" [matTooltip]="'common_btn_duplicate' | translate" class="action-btn duplicate">
                                <mat-icon>content_copy</mat-icon>
                              </button>
                              <button mat-icon-button (click)="editOperation(operation)" [matTooltip]="'common_btn_edit' | translate" class="action-btn edit">
                                <mat-icon>edit</mat-icon>
                              </button>
                              <button mat-icon-button (click)="onDeleteOperation(solution, indexOperation, operation?.id)" [matTooltip]="'common_btn_delete' | translate" class="action-btn delete">
                                <mat-icon>delete_outline</mat-icon>
                              </button>
                            </div>
                          </div>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div
                      class="operation"
                      cdkDropList
                      #operationDropList="cdkDropList"
                      [cdkDropListData]="getDropListData(operation)"
                      [cdkDropListConnectedTo]="operationDropListsArray"
                      [cdkDropListSortingDisabled]="true"
                      (cdkDropListDropped)="onProductDrop($event)">
                      <div class="operation-info-card">
                        <div class="info-row">
                          <div class="info-field">
                            <span class="info-label">{{ 'project_solutions_field_creator' | translate }}</span>
                            <div class="creator-chip">
                              <mat-icon class="creator-icon">person</mat-icon>
                              <span>{{ operation?.creator || '' }}</span>
                            </div>
                          </div>
                          <div class="info-field info-field-grow">
                            <span class="info-label">{{ 'project_solutions_field_operation_type' | translate }} *</span>
                            <mat-select class="operation-type-select" #typeSelect required [(ngModel)]="operation.type" [ngModelOptions]="{ standalone: true }" (selectionChange)="autoSaveProject(currentItem)">
                              <mat-option *ngFor="let pt of filteredProjectTypes" [value]="pt.operationType"> {{ pt.displayName }} </mat-option>
                            </mat-select>
                          </div>
                        </div>
                        <div class="info-field">
                          <span class="info-label">{{ 'project_solutions_field_operation_description' | translate }}</span>
                          <textarea class="operation-description-textarea" rows="2" [(ngModel)]="operation.description" [ngModelOptions]="{ standalone: true }" (ngModelChange)="markUnsavedIfDeferred()"></textarea>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <mat-tab-group animationDuration="0ms">
                            <mat-tab [label]="'project_tab_input_products' | translate">
                              <div>
                                <mat-accordion hideToggle>
                                  <mat-expansion-panel expanded [disabled]="true" class="static-panel">
                                    <mat-expansion-panel-header>
                                      <mat-panel-title>
                                        <div class="row text-bold products-table-header">
                                          <div class="col-1 text-center badge-col"></div>
                                          <div class="col-2">{{ 'project_col_product' | translate }}</div>
                                          <div class="col-1 transport-col">{{ 'project_col_transport' | translate }}</div>
                                          <div class="col-1 energy-col">{{ 'project_col_energy' | translate }}</div>
                                          <div class="col-1 text-center">{{ 'project_col_multimodal_transport' | translate }}</div>
                                          <div class="col-1">{{ 'project_col_distance' | translate }}</div>
                                          <div class="col-1 text-center">{{ 'project_col_double_freight' | translate }}</div>
                                          <div class="col-1">{{ 'project_col_work_unit' | translate }}</div>
                                          <div class="col-1">{{ 'project_col_quantity' | translate }}</div>
                                          <div class="col-1 tco2eq-col">{{ indicators[indexEnergyToShow]?.workUnityDisplayShortName }}</div>
                                        </div>
                                      </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <div
                                      class="row"
                                      cdkDrag
                                      [cdkDragData]="{ item: item, type: 'input', operationId: operation.id }"
                                      [ngClass]="{
                                        rowItem: indexInputPro % 2 == 0,
                                        'expandable-row': item.pipeProduct || item.cableProduct
                                      }"
                                      *ngFor="let item of operation?.detailedOperation?.inputProducts; let indexInputPro = index">
                                      <div *cdkDragPreview class="product-drag-preview">
                                        <mat-icon>drag_indicator</mat-icon>
                                        <span>{{ item.displayName }} [{{ item.productCode }}]</span>
                                      </div>
                                      <div class="col-1 text-center badge-col">
                                        <badge-statut [item]="item" [itemType]="'operation-product'"></badge-statut>
                                      </div>
                                      <div class="col-2 operation-title">
                                        <editable-field
                                          (onClick)="editProductName(item, operation.id, operation?.type)"
                                          [showCustomContent]="false"
                                          [href]="(item.detailedResource ? SiteMapUrl.MenuFormula : SiteMapUrl.MenuProduct) + '/' + item.productId"
                                          [target]="'_blank'">
                                          {{ item.displayName }}
                                          [{{ item.productCode }}]
                                        </editable-field>
                                        <mat-icon class="deleted" [matTooltip]="'project_error_product_deleted' | translate: { name: item.displayName }" *ngIf="item.productIsDeleted"> error </mat-icon>
                                        <mat-icon class="deleted" [matTooltip]="'project_error_product_unavailable' | translate: { name: item.displayName }" *ngIf="item.resourceNotAvailableForThisVersion"> error </mat-icon>
                                      </div>
                                      <div class="col-1 transport-col">
                                        <mat-expansion-panel *ngIf="item.pipeProduct; else productTransport" class="expansion-product panel-overflow" [expanded]="getPanelState(item.productId)" hideToggle>
                                          <mat-expansion-panel-header #panelProductTransport (click)="panelProductTransport._toggle()" class="expansion-product-header">
                                            <div class="operation-title" (click)="toggleProductPanels(item.productId)">
                                              <mat-icon>
                                                {{ panelProductTransport._isExpanded() ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}
                                              </mat-icon>
                                              {{ item.transportName ? item.transportName : ('common_no_transport' | translate) }}
                                              <mat-icon class="deleted" [matTooltip]="'project_error_transport_deleted' | translate: { name: item.transportName }" *ngIf="item.transportIsDeleted"> error </mat-icon>
                                              <mat-icon
                                                class="deleted"
                                                [matTooltip]="'project_error_transport_unavailable' | translate: { name: item.transportName }"
                                                *ngIf="!item.transportIsDeleted && item.transportId && item.transportationNotAvailableForThisVersion">
                                                error
                                              </mat-icon>
                                            </div>
                                          </mat-expansion-panel-header>
                                          <mat-list role="list" *ngIf="item.pipeProduct">
                                            <mat-list-item>
                                              <mat-icon class="engin-icon" mat-list-icon> horizontal_rule </mat-icon>
                                              {{ 'project_product_production_site' | translate }}
                                              {{ item.productionSite }}
                                            </mat-list-item>
                                          </mat-list>
                                        </mat-expansion-panel>

                                        <ng-template #productTransport>
                                          <editable-field [href]="SiteMapUrl.MenuTransport + '/' + item.transportId" [target]="'_blank'">
                                            {{ item.transportName ? item.transportName : ('common_no_transport' | translate) }}
                                            <mat-icon class="deleted" [matTooltip]="'project_error_transport_deleted' | translate: { name: item.transportName }" *ngIf="item.transportIsDeleted"> error </mat-icon>
                                            <mat-icon
                                              class="deleted"
                                              [matTooltip]="'project_error_transport_unavailable' | translate: { name: item.transportName }"
                                              *ngIf="!item.transportIsDeleted && item.transportId && item.transportationNotAvailableForThisVersion">
                                              error
                                            </mat-icon>

                                            <div slot="dialog-content" *ngIf="operation && operation.id">
                                              <mat-form-field>
                                                <mat-label>{{ 'common_field_transport' | translate }}</mat-label>
                                                <mat-select
                                                  name="transportName"
                                                  value="{{ item.transportId || '0' }}"
                                                  (selectionChange)="
                                                    updateItemData(
                                                      {
                                                        transportId: $event.value
                                                      },
                                                      item,
                                                      operation.id
                                                    )
                                                  ">
                                                  <mat-option value="0">{{ 'common_no_transport' | translate }}</mat-option>
                                                  <mat-option *ngFor="let t of inputProductsList" [value]="t.resourceId">
                                                    {{ t?.displayName }}
                                                  </mat-option>
                                                </mat-select>
                                              </mat-form-field>
                                            </div>
                                          </editable-field>
                                        </ng-template>
                                      </div>
                                      <div class="col-1 energy-col">
                                        <div *ngIf="!item.isMultimodal">
                                          <p *ngIf="!!item.energieDescription">{{ item?.energyName ? item?.energyName : item?.energieDescription ? item?.energieDescription : ('common_no_energy' | translate) }}</p>
                                          <editable-field *ngIf="!item.energieDescription" [href]="SiteMapUrl.MenuEnergie + '/transportation/' + item.energyId" [target]="'_blank'">
                                            {{ item?.energyName ? item?.energyName : item?.energieDescription ? item?.energieDescription : ('common_no_energy' | translate) }}

                                            <div slot="dialog-content" *ngIf="operation && operation.id">
                                              <mat-form-field>
                                                <mat-label>{{ 'common_field_energy' | translate }}</mat-label>
                                                <mat-select
                                                  name="energyName"
                                                  value="{{ item.energyId || '0' }}"
                                                  (selectionChange)="
                                                    updateItemData(
                                                      {
                                                        energyId: $event.value
                                                      },
                                                      item,
                                                      operation.id
                                                    )
                                                  ">
                                                  <mat-option value="0">{{ 'common_no_energy' | translate }}</mat-option>
                                                  <mat-option *ngFor="let e of energies" [value]="e?.resourceId">
                                                    {{ e?.displayName }}
                                                  </mat-option>
                                                </mat-select>
                                              </mat-form-field>
                                            </div>
                                          </editable-field>
                                          <mat-icon class="deleted" [matTooltip]="'project_error_energy_deleted' | translate: { name: item.energyName }" *ngIf="item.energyIsDeleted"> error </mat-icon>
                                        </div>
                                      </div>
                                      <div *ngIf="operation && operation.id" class="col-1 text-center icon-color">
                                        <mat-icon (click)="addMultiModalTransport(operation.id, item)" [matTooltip]="'project_col_multimodal_transport' | translate"> add</mat-icon>
                                        <mat-icon (click)="deleteMultimodalTransport(operation.id, item)" *ngIf="item.isMultimodal; else elseBlockMultimodal"> delete_outline </mat-icon>
                                        <ng-template #elseBlockMultimodal>
                                          <mat-icon></mat-icon>
                                        </ng-template>
                                      </div>
                                      <div class="col-1 text-center">
                                        <div *ngIf="!item.isMultimodal && operation && operation.id">
                                          <editable-field>
                                            {{ item.distance ? item.distance : 0 }}

                                            <div slot="dialog-content">
                                              <mat-form-field>
                                                <mat-label>{{ 'common_field_distance' | translate }}</mat-label>
                                                <input
                                                  matInput
                                                  type="number"
                                                  [(ngModel)]="item.distance"
                                                  [ngModelOptions]="{ standalone: true }"
                                                  name="distance"
                                                  min="0"
                                                  step="0.1"
                                                  cdkFocusInitial
                                                  required
                                                  (blur)="
                                                    updateItemData(
                                                      {
                                                        distance: getInputValue($event)
                                                      },
                                                      item,
                                                      operation.id
                                                    )
                                                  " />
                                              </mat-form-field>
                                            </div>
                                          </editable-field>
                                        </div>
                                      </div>
                                      <div class="col-1 text-center" *ngIf="operation && operation.id">
                                        <div *ngIf="!item.isMultimodal">
                                          <mat-checkbox [checked]="item?.isDoubleFreight ? true : false" (change)="changeFret(operation.id, item)"> </mat-checkbox>
                                        </div>
                                      </div>
                                      <div class="col-1">
                                        <div>
                                          {{ item?.workUnit }}
                                        </div>
                                      </div>
                                      <div class="col-1">
                                        <mat-expansion-panel *ngIf="item.pipeProduct || item.cableProduct; else productQuantity" class="expansion-product panel-overflow panel-productQuantity" [expanded]="getPanelState(item.productId)" hideToggle>
                                          <mat-expansion-panel-header #panelProductQuantity (click)="panelProductQuantity._toggle()" class="expansion-product-header">
                                            <div class="operation-title" (click)="toggleProductPanels(item.productId)">
                                              <mat-icon>
                                                {{ panelProductQuantity._isExpanded() ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}
                                              </mat-icon>
                                              {{ item?.quantity }}
                                            </div>
                                          </mat-expansion-panel-header>
                                          <mat-list role="list" *ngIf="item.pipeProduct">
                                            <mat-list-item>
                                              <mat-icon class="engin-icon" mat-list-icon> horizontal_rule </mat-icon>
                                              {{ 'project_product_dn_mm' | translate }}
                                              {{ item.diameter }}
                                            </mat-list-item>
                                            <mat-list-item>
                                              <mat-icon class="engin-icon" mat-list-icon> horizontal_rule </mat-icon>
                                              <mat-label *ngIf="item.pipeProduct == 1">{{ 'project_product_unit_weight_ml' | translate }} </mat-label>
                                              <mat-label *ngIf="item.pipeProduct == 2">{{ 'project_product_unit_weight_unit' | translate }} </mat-label>
                                              {{ item.unitWeight }}
                                            </mat-list-item>
                                          </mat-list>
                                          <mat-list role="list" *ngIf="item.cableProduct">
                                            <mat-list-item>
                                              <mat-icon class="engin-icon" mat-list-icon> horizontal_rule </mat-icon>
                                              {{ 'project_product_section_mm2' | translate }}
                                              {{ item.section }}
                                            </mat-list-item>
                                            <mat-list-item>
                                              <mat-icon class="engin-icon" mat-list-icon> horizontal_rule </mat-icon>
                                              {{ 'project_product_nb_conductors' | translate }}
                                              {{ item.nbConductors }}
                                            </mat-list-item>
                                          </mat-list>
                                        </mat-expansion-panel>
                                        <ng-template #productQuantity>
                                          <div *ngIf="operation && operation.id">
                                            <editable-field>
                                              {{ item?.quantity }}
                                              <div slot="dialog-content">
                                                <mat-form-field>
                                                  <mat-label>{{ 'common_field_quantity' | translate }}</mat-label>
                                                  <input
                                                    matInput
                                                    type="number"
                                                    [(ngModel)]="item.quantity"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    name="quantity"
                                                    min="0"
                                                    step="any"
                                                    cdkFocusInitial
                                                    required
                                                    (blur)="
                                                      updateItemData(
                                                        {
                                                          quantity: getInputValue($event)
                                                        },
                                                        item,
                                                        operation.id
                                                      )
                                                    " />
                                                </mat-form-field>
                                              </div>
                                            </editable-field>
                                          </div>
                                        </ng-template>
                                      </div>
                                      <div class="col-1 tco2eq-col">
                                        <span *ngIf="indicators[indexEnergyToShow]?.code !== 'CO'; else inputProductCOValue">
                                          {{ labelI18n.exponential(getProductCeuValue(item), 2) }}
                                        </span>
                                        <ng-template #inputProductCOValue>
                                          {{ getProductCeuValue(item) | localizedNumber: '1.2-2' }}
                                        </ng-template>
                                      </div>
                                      <div *ngIf="operation && operation.id" class="col-1 icon-color text-center">
                                        <mat-icon (click)="editProduitOperation(operation.id, item)" *ngIf="!item.isMultimodal; else elseBlock"> edit</mat-icon>
                                        <ng-template #elseBlock>
                                          <mat-icon (click)="editProduitMultimodalQuantity(operation.id, item)"> edit</mat-icon>
                                        </ng-template>
                                        <mat-icon (click)="duplicateProduct(operation.id, operation?.detailedOperation?.inputProducts, indexInputPro, true)" [matTooltip]="'common_btn_duplicate' | translate"> content_copy </mat-icon>
                                        <mat-icon (click)="deleteProduitOrEnginOperation(operation.id, operation?.detailedOperation?.inputProducts, indexInputPro)"> delete_outline </mat-icon>
                                      </div>
                                    </div>
                                  </mat-expansion-panel>
                                </mat-accordion>
                              </div>

                              <div class="add-item-dashed" *ngIf="operation && operation.id" (click)="addInputProduit(operation.id, operation?.detailedOperation?.inputProducts || [], operation?.type)">
                                <mat-icon>add_circle_outline</mat-icon>
                                <span>{{ 'project_solutions_add_product' | translate }}</span>
                              </div>
                            </mat-tab>

                            <mat-tab [label]="'project_tab_output_products' | translate">
                              <div>
                                <mat-accordion hideToggle>
                                  <mat-expansion-panel expanded [disabled]="true" class="static-panel">
                                    <mat-expansion-panel-header>
                                      <mat-panel-title>
                                        <div class="row text-bold products-table-header">
                                          <div class="col-1 text-center badge-col"></div>
                                          <div class="col-2">{{ 'project_col_product' | translate }}</div>
                                          <div class="col-1 transport-col">{{ 'project_col_transport' | translate }}</div>
                                          <div class="col-1 energy-col">{{ 'project_col_energy' | translate }}</div>
                                          <div class="col-1 text-center">{{ 'project_col_multimodal_transport' | translate }}</div>
                                          <div class="col-1">{{ 'project_col_distance' | translate }}</div>
                                          <div class="col-1 text-center">{{ 'project_col_double_freight' | translate }}</div>
                                          <div class="col-1">{{ 'project_col_work_unit' | translate }}</div>
                                          <div class="col-1">{{ 'project_col_quantity' | translate }}</div>
                                          <div class="col-1 tco2eq-col">{{ indicators[indexEnergyToShow]?.workUnityDisplayShortName }}</div>
                                        </div>
                                      </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <div
                                      class="row"
                                      cdkDrag
                                      [cdkDragData]="{ item: item, type: 'output', operationId: operation.id }"
                                      [ngClass]="{
                                        rowItem: indexOutPro % 2 == 0,
                                        'expandable-row': item.pipeProduct || item.cableProduct
                                      }"
                                      *ngFor="let item of operation?.detailedOperation?.outputProducts; let indexOutPro = index">
                                      <div *cdkDragPreview class="product-drag-preview">
                                        <mat-icon>drag_indicator</mat-icon>
                                        <span>{{ item.displayName }} [{{ item.productCode }}]</span>
                                      </div>
                                      <div class="col-1 text-center badge-col">
                                        <badge-statut [item]="item" [itemType]="'operation-product'"></badge-statut>
                                      </div>
                                      <div class="col-2 operation-title">
                                        <editable-field (onClick)="editProductOutputName(item, operation.id, operation?.type)" [showCustomContent]="false" [href]="SiteMapUrl.MenuProduct + '/' + item.productId" [target]="'_blank'">
                                          {{ item.displayName }}
                                          [{{ item.productCode }}]
                                        </editable-field>
                                        <mat-icon class="deleted" [matTooltip]="'project_error_product_deleted' | translate: { name: item.displayName }" *ngIf="item.productIsDeleted"> error </mat-icon>
                                        <mat-icon class="deleted" [matTooltip]="'project_error_product_unavailable' | translate: { name: item.displayName }" *ngIf="item.resourceNotAvailableForThisVersion"> error </mat-icon>
                                      </div>
                                      <div class="col-1 transport-col">
                                        <mat-expansion-panel *ngIf="item.pipeProduct; else productTransport" class="expansion-product panel-overflow" [expanded]="getPanelState(item.productId)" hideToggle>
                                          <mat-expansion-panel-header #panelProductTransport (click)="panelProductTransport._toggle()" class="expansion-product-header">
                                            <div class="operation-title" (click)="toggleProductPanels(item.productId)">
                                              <mat-icon>
                                                {{ panelProductTransport._isExpanded() ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}
                                              </mat-icon>
                                              {{ item.transportName ? item.transportName : ('common_no_transport' | translate) }}
                                              <mat-icon class="deleted" [matTooltip]="'project_error_transport_deleted' | translate: { name: item.transportName }" *ngIf="item.transportIsDeleted"> error </mat-icon>
                                              <mat-icon
                                                class="deleted"
                                                [matTooltip]="'project_error_transport_unavailable' | translate: { name: item.transportName }"
                                                *ngIf="!item.transportIsDeleted && item.transportId && item.transportationNotAvailableForThisVersion">
                                                error
                                              </mat-icon>
                                            </div>
                                          </mat-expansion-panel-header>
                                          <mat-list role="list" *ngIf="item.pipeProduct">
                                            <mat-list-item>
                                              <mat-icon class="engin-icon" mat-list-icon> horizontal_rule </mat-icon>
                                              {{ 'project_product_production_site' | translate }}
                                              {{ item.productionSite }}
                                            </mat-list-item>
                                          </mat-list>
                                        </mat-expansion-panel>

                                        <ng-template #productTransport>
                                          <editable-field [href]="SiteMapUrl.MenuTransport + '/' + item.transportId" [target]="'_blank'">
                                            {{ item.transportName ? item.transportName : ('common_no_transport' | translate) }}
                                            <mat-icon class="deleted" [matTooltip]="'project_error_transport_deleted' | translate: { name: item.transportName }" *ngIf="item.transportIsDeleted"> error </mat-icon>
                                            <mat-icon
                                              class="deleted"
                                              [matTooltip]="'project_error_transport_unavailable' | translate: { name: item.transportName }"
                                              *ngIf="!item.transportIsDeleted && item.transportId && item.transportationNotAvailableForThisVersion">
                                              error
                                            </mat-icon>

                                            <div slot="dialog-content" *ngIf="operation && operation.id">
                                              <mat-form-field>
                                                <mat-label>{{ 'common_field_transport' | translate }}</mat-label>
                                                <mat-select
                                                  name="transportName"
                                                  value="{{ item.transportId || '0' }}"
                                                  (selectionChange)="
                                                    updateItemData(
                                                      {
                                                        transportId: $event.value
                                                      },
                                                      item,
                                                      operation.id
                                                    )
                                                  ">
                                                  <mat-option value="0">{{ 'common_no_transport' | translate }}</mat-option>
                                                  <mat-option *ngFor="let t of inputProductsList" [value]="t?.resourceId">
                                                    {{ t?.displayName }}
                                                  </mat-option>
                                                </mat-select>
                                              </mat-form-field>
                                            </div>
                                          </editable-field>
                                        </ng-template>
                                      </div>
                                      <div class="col-1 energy-col">
                                        <div *ngIf="!item.isMultimodal">
                                          <editable-field [href]="SiteMapUrl.MenuEnergie + '/transportation/' + item.energyId" [target]="'_blank'">
                                            {{ item?.energyName ? item?.energyName : item?.energieDescription ? item?.energieDescription : ('common_no_energy' | translate) }}

                                            <div slot="dialog-content" *ngIf="operation && operation.id">
                                              <mat-form-field>
                                                <mat-label>{{ 'common_field_energy' | translate }}</mat-label>
                                                <mat-select
                                                  name="energyName"
                                                  value="{{ item.energyId || '0' }}"
                                                  (selectionChange)="
                                                    updateItemData(
                                                      {
                                                        energyId: $event.value
                                                      },
                                                      item,
                                                      operation.id
                                                    )
                                                  ">
                                                  <mat-option value="0">{{ 'common_no_energy' | translate }}</mat-option>
                                                  <mat-option *ngFor="let e of energies" [value]="e?.resourceId">
                                                    {{ e?.displayName }}
                                                  </mat-option>
                                                </mat-select>
                                              </mat-form-field>
                                            </div>
                                          </editable-field>
                                          <mat-icon class="deleted" [matTooltip]="'project_error_energy_deleted' | translate: { name: item.energyName }" *ngIf="item.energyIsDeleted"> error </mat-icon>
                                        </div>
                                      </div>
                                      <div *ngIf="operation && operation.id" class="col-1 text-center icon-color">
                                        <mat-icon (click)="addMultiModalTransport(operation.id, item)" [matTooltip]="'project_col_multimodal_transport' | translate"> add</mat-icon>
                                        <mat-icon (click)="deleteMultimodalTransport(operation.id, item)" *ngIf="item.isMultimodal; else elseBlockMultimodal"> delete_outline </mat-icon>
                                        <ng-template #elseBlockMultimodal>
                                          <mat-icon></mat-icon>
                                        </ng-template>
                                      </div>
                                      <div class="col-1 text-center">
                                        <div *ngIf="!item.isMultimodal && operation && operation.id">
                                          <editable-field>
                                            {{ item.distance ? item.distance : 0 }}

                                            <div slot="dialog-content">
                                              <mat-form-field>
                                                <mat-label>{{ 'common_field_distance' | translate }}</mat-label>
                                                <input
                                                  matInput
                                                  type="number"
                                                  [(ngModel)]="item.distance"
                                                  [ngModelOptions]="{ standalone: true }"
                                                  name="distance"
                                                  min="0"
                                                  step="0.1"
                                                  cdkFocusInitial
                                                  required
                                                  (blur)="
                                                    updateItemData(
                                                      {
                                                        distance: getInputValue($event)
                                                      },
                                                      item,
                                                      operation.id
                                                    )
                                                  " />
                                              </mat-form-field>
                                            </div>
                                          </editable-field>
                                        </div>
                                      </div>
                                      <div class="col-1 text-center" *ngIf="operation && operation.id">
                                        <div *ngIf="!item.isMultimodal">
                                          <mat-checkbox [checked]="item?.isDoubleFreight ? true : false" (change)="changeFret(operation.id, item)"> </mat-checkbox>
                                        </div>
                                      </div>
                                      <div class="col-1">
                                        <div>
                                          {{ item?.workUnit }}
                                        </div>
                                      </div>
                                      <div class="col-1">
                                        <mat-expansion-panel *ngIf="item.pipeProduct || item.cableProduct; else productQuantity" class="expansion-product panel-overflow panel-productQuantity" [expanded]="getPanelState(item.productId)" hideToggle>
                                          <mat-expansion-panel-header #panelProductQuantity (click)="panelProductQuantity._toggle()" class="expansion-product-header">
                                            <div class="operation-title" (click)="toggleProductPanels(item.productId)">
                                              <mat-icon>
                                                {{ panelProductQuantity._isExpanded() ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}
                                              </mat-icon>
                                              {{ item?.quantity }}
                                            </div>
                                          </mat-expansion-panel-header>
                                          <mat-list role="list" *ngIf="item.pipeProduct">
                                            <mat-list-item>
                                              <mat-icon class="engin-icon" mat-list-icon> horizontal_rule </mat-icon>
                                              {{ 'project_product_dn_mm' | translate }}
                                              {{ item.diameter }}
                                            </mat-list-item>
                                            <mat-list-item>
                                              <mat-icon class="engin-icon" mat-list-icon> horizontal_rule </mat-icon>
                                              <mat-label *ngIf="item.pipeProduct == 1">{{ 'project_product_unit_weight_ml' | translate }} </mat-label>
                                              <mat-label *ngIf="item.pipeProduct == 2">{{ 'project_product_unit_weight_unit' | translate }} </mat-label>
                                              {{ item.unitWeight }}
                                            </mat-list-item>
                                          </mat-list>
                                          <mat-list role="list" *ngIf="item.cableProduct">
                                            <mat-list-item>
                                              <mat-icon class="engin-icon" mat-list-icon> horizontal_rule </mat-icon>
                                              {{ 'project_product_section_mm2' | translate }}
                                              {{ item.section }}
                                            </mat-list-item>
                                            <mat-list-item>
                                              <mat-icon class="engin-icon" mat-list-icon> horizontal_rule </mat-icon>
                                              {{ 'project_product_nb_conductors' | translate }}
                                              {{ item.nbConductors }}
                                            </mat-list-item>
                                          </mat-list>
                                        </mat-expansion-panel>
                                        <ng-template #productQuantity>
                                          <div *ngIf="operation && operation.id">
                                            <editable-field>
                                              {{ item?.quantity }}
                                              <div slot="dialog-content">
                                                <mat-form-field>
                                                  <mat-label>{{ 'common_field_quantity' | translate }}</mat-label>
                                                  <input
                                                    matInput
                                                    type="number"
                                                    [(ngModel)]="item.quantity"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    name="quantity"
                                                    min="0"
                                                    step="any"
                                                    cdkFocusInitial
                                                    required
                                                    (blur)="
                                                      updateItemData(
                                                        {
                                                          quantity: getInputValue($event)
                                                        },
                                                        item,
                                                        operation.id
                                                      )
                                                    " />
                                                </mat-form-field>
                                              </div>
                                            </editable-field>
                                          </div>
                                        </ng-template>
                                      </div>
                                      <div class="col-1 tco2eq-col">
                                        <span *ngIf="indicators[indexEnergyToShow]?.code !== 'CO'; else outputProductCOValue">
                                          {{ labelI18n.exponential(getProductCeuValue(item), 2) }}
                                        </span>
                                        <ng-template #outputProductCOValue>
                                          {{ getProductCeuValue(item) | localizedNumber: '1.2-2' }}
                                        </ng-template>
                                      </div>
                                      <div *ngIf="operation && operation.id" class="col-1 icon-color text-center">
                                        <mat-icon (click)="editProduitOperation(operation.id, item)" *ngIf="!item.isMultimodal; else elseBlock"> edit</mat-icon>
                                        <ng-template #elseBlock>
                                          <mat-icon (click)="editProduitMultimodalQuantity(operation.id, item)"> edit</mat-icon>
                                        </ng-template>
                                        <mat-icon (click)="duplicateProduct(operation.id, operation?.detailedOperation?.outputProducts, indexOutPro, false)" [matTooltip]="'common_btn_duplicate' | translate"> content_copy </mat-icon>
                                        <mat-icon (click)="deleteProduitOrEnginOperation(operation.id, operation?.detailedOperation?.outputProducts, indexOutPro)"> delete_outline </mat-icon>
                                      </div>
                                    </div>
                                  </mat-expansion-panel>
                                </mat-accordion>
                              </div>
                              <div class="add-item-dashed" *ngIf="operation && operation.id" (click)="addOutputProduit(operation.id, operation?.detailedOperation?.outputProducts || [], operation?.type)">
                                <mat-icon>add_circle_outline</mat-icon>
                                <span>{{ 'project_solutions_add_product' | translate }}</span>
                              </div>
                            </mat-tab>
                            <mat-tab [label]="'project_tab_engines' | translate">
                              <div>
                                <mat-accordion hideToggle>
                                  <mat-expansion-panel expanded [disabled]="true" class="static-panel">
                                    <mat-expansion-panel-header>
                                      <mat-panel-title>
                                        <div class="row text-bold products-table-header">
                                          <div class="col-1 text-center badge-col"></div>
                                          <div class="col-4">{{ 'project_col_engin' | translate }}</div>
                                          <div class="col-2">{{ 'project_col_energy' | translate }}</div>
                                          <div class="col-2">
                                            <mat-select
                                              name="displayAsDay"
                                              panelClass="engin-display-panel"
                                              [(ngModel)]="displayAsDay"
                                              [ngModelOptions]="{
                                                standalone: true
                                              }">
                                              <mat-option [value]="true"> {{ 'project_engin_display_days' | translate }} </mat-option>
                                              <mat-option [value]="false"> {{ 'project_engin_display_hours' | translate }} </mat-option>
                                            </mat-select>
                                          </div>
                                          <div class="col-1">{{ this.indicators[indexEnergyToShow]?.workUnityDisplayShortName }}</div>
                                        </div>
                                      </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <div
                                      class="row"
                                      cdkDrag
                                      [cdkDragData]="{ item: item, type: 'vehicle', operationId: operation.id }"
                                      [ngClass]="{
                                        rowItem: indexVeh % 2 == 0
                                      }"
                                      *ngFor="let item of operation?.detailedOperation?.vehicles; let indexVeh = index">
                                      <div *cdkDragPreview class="product-drag-preview">
                                        <mat-icon>drag_indicator</mat-icon>
                                        <span>{{ item.displayName }}</span>
                                      </div>
                                      <div class="col-1 text-center badge-col">
                                        <badge-statut [item]="item" [itemType]="'operation-product'"></badge-statut>
                                      </div>
                                      <div class="col-4">
                                        <mat-expansion-panel *ngIf="item.isAtelier && item.atelierEngins && item.atelierEngins.length > 0; else engin" class="expansion-atelier" hideToggle>
                                          <mat-expansion-panel-header #panelAtelier (click)="panelAtelier._toggle()">
                                            <div class="operation-title" (click)="panelAtelier._toggle()">
                                              <mat-icon>
                                                {{ panelAtelier._isExpanded() ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}
                                              </mat-icon>
                                              <editable-field [showCustomContent]="false" [href]="SiteMapUrl.MenuEnginAtelier + '/atelier/' + item.vehicleId" [target]="'_blank'">
                                                {{ item.displayName }}
                                              </editable-field>
                                            </div>
                                          </mat-expansion-panel-header>
                                          <mat-list role="list">
                                            <mat-list-item *ngFor="let engin of item.atelierEngins">
                                              <mat-icon class="engin-icon" mat-list-icon> horizontal_rule </mat-icon>
                                              {{ engin.quantity }}
                                              {{ engin.displayName }}
                                              — {{ engin.energyName ? engin.energyName : ('common_other_energy' | translate) }}
                                            </mat-list-item>
                                          </mat-list>
                                        </mat-expansion-panel>
                                        <ng-template #engin>
                                          <div class="engin-font" *ngIf="operation && operation.id">
                                            <editable-field (onClick)="editOperationEngin(item, operation.id, operation?.type)" [showCustomContent]="false" [href]="SiteMapUrl.MenuEnginAtelier + '/engin/' + item.vehicleId" [target]="'_blank'">
                                              {{ item.displayName }}
                                            </editable-field>
                                            <mat-icon class="deleted" [matTooltip]="'project_error_engin_deleted' | translate: { name: item.displayName }" *ngIf="item.transportIsDeleted"> error </mat-icon>
                                            <mat-icon class="deleted" [matTooltip]="'project_error_engin_unavailable' | translate: { name: item.displayName }" *ngIf="item.resourceNotAvailableForThisVersion"> error </mat-icon>
                                          </div>
                                        </ng-template>
                                      </div>

                                      <div class="col-2" *ngIf="item.isAtelier"></div>
                                      <div class="col-2" *ngIf="!item.isAtelier">
                                        <editable-field [href]="SiteMapUrl.MenuEnergie + '/vehicle/' + item.energyId" [target]="'_blank'" [linkDisabled]="!item.energyId || item.energyId === EMPTY_GUID">
                                          {{ item?.energyName ? item?.energyName : ('common_other_energy' | translate) }}

                                          <div slot="dialog-content" *ngIf="operation && operation.id">
                                            <mat-form-field>
                                              <mat-label>{{ 'project_col_energy' | translate }}</mat-label>
                                              <mat-select
                                                name="energyName"
                                                value="{{ item.energyId || EMPTY_GUID }}"
                                                (selectionChange)="
                                                  updateItemData(
                                                    {
                                                      energyId: $event.value
                                                    },
                                                    item,
                                                    operation.id
                                                  )
                                                ">
                                                <mat-option [value]="EMPTY_GUID">{{ 'common_other_energy' | translate }}</mat-option>
                                                <mat-option *ngFor="let e of vehicleEnergies" [value]="e?.resourceId">
                                                  {{ e?.displayName }}
                                                </mat-option>
                                              </mat-select>
                                            </mat-form-field>
                                          </div>
                                        </editable-field>
                                      </div>

                                      <div class="col-2 text-center">
                                        <editable-field>
                                          {{ this.displayAsDay ? item?.quantity : this.getHoursFromDay(item?.quantity) }}

                                          <div slot="dialog-content" *ngIf="operation && operation.id">
                                            <mat-form-field>
                                              <mat-label *ngIf="this.displayAsDay">{{ 'project_engin_quantity_days' | translate }}</mat-label>
                                              <mat-label *ngIf="!this.displayAsDay">{{ 'project_engin_quantity_hours' | translate }}</mat-label>

                                              <input
                                                matInput
                                                type="number"
                                                [(ngModel)]="item.quantity"
                                                [ngModelOptions]="{ standalone: true }"
                                                name="quantity"
                                                min="0"
                                                step="any"
                                                cdkFocusInitial
                                                required
                                                (blur)="updateEnginQuantity(item, getInputValue($event) || 0, operation.id)" />
                                            </mat-form-field>
                                          </div>
                                        </editable-field>
                                      </div>
                                      <div class="col-1">
                                        <span *ngIf="this.indicators[indexEnergyToShow]?.code !== 'CO'; else outputProductCOValue">
                                          {{ labelI18n.exponential(getProductCeuValue(item), 2) }}
                                        </span>
                                        <ng-template #outputProductCOValue>
                                          {{ getProductCeuValue(item) | localizedNumber: '1.2-2' }}
                                        </ng-template>
                                      </div>
                                      <div class="col-2 icon-color text-center">
                                        <mat-icon *ngIf="operation && operation.id" (click)="editEnginOperation(item, operation.id)"> edit</mat-icon>
                                        <mat-icon *ngIf="operation && operation.id" (click)="deleteProduitOrEnginOperation(operation.id, operation?.detailedOperation?.vehicles, indexVeh)"> delete_outline </mat-icon>
                                      </div>
                                    </div>
                                    <div class="row" [ngClass]="{ rowItem: indexVeh % 2 == 0 }" *ngFor="let item of operation?.detailedOperation?.dredging; let indexVeh = index">
                                      <div class="col-1 text-center badge-col">
                                        <badge-statut [item]="item" [itemType]="'operation-product'"></badge-statut>
                                      </div>
                                      <div class="col-6">
                                        {{ item.displayName }}
                                      </div>
                                      <div class="col-2 text-center">{{ item?.execPhaseDuration }} Semaine(s)</div>
                                      <div class="col-1">
                                        <span *ngIf="this.indicators[indexEnergyToShow]?.code !== 'CO'; else outputProductCOValue">
                                          {{ item.totalMj != null ? labelI18n.exponential(item.totalMj, 2) : '' }}
                                        </span>
                                        <ng-template #outputProductCOValue>
                                          {{ item.totalCo2Eq | localizedNumber: '1.2-2' }}
                                        </ng-template>
                                      </div>
                                      <div class="col-2 icon-color text-center">
                                        <mat-icon *ngIf="operation && operation.id" (click)="editEnginOperation(item, operation.id, false, true)"> edit</mat-icon>
                                        <mat-icon *ngIf="operation && operation.id" (click)="deleteProduitOrEnginOperation(operation.id, operation?.detailedOperation?.dredging, indexVeh)"> delete_outline </mat-icon>
                                      </div>
                                    </div>

                                    <div class="row" [ngClass]="{ rowItem: indexVeh % 2 == 0 }" *ngFor="let item of operation?.detailedOperation?.tunneling; let indexVeh = index">
                                      <div class="col-1 text-center badge-col">
                                        <badge-statut [item]="item" [itemType]="'operation-product'"></badge-statut>
                                      </div>
                                      <div class="col-4">
                                        {{ item.displayName }}
                                      </div>
                                      <div class="col-2">
                                        {{ item?.energyName ? item?.energyName : ('common_other_energy' | translate) }}
                                      </div>
                                      <div class="col-2 text-center">
                                        {{ this.displayAsDay ? item?.presenceDuration : this.getHoursFromDay(item?.presenceDuration) }}
                                      </div>
                                      <div class="col-1">
                                        <span *ngIf="this.indicators[indexEnergyToShow]?.code !== 'CO'; else outputProductCOValue">
                                          {{ item.grandTotalMj != null ? labelI18n.exponential(item.grandTotalMj, 2) : '' }}
                                        </span>
                                        <ng-template #outputProductCOValue>
                                          {{ item.grandTotalCo2Eq | localizedNumber: '1.2-2' }}
                                        </ng-template>
                                      </div>
                                      <div class="col-2 icon-color text-center">
                                        <mat-icon *ngIf="operation && operation.id" (click)="editEnginOperation(item, operation.id, true, false)"> edit</mat-icon>
                                        <mat-icon *ngIf="operation && operation.id" (click)="deleteProduitOrEnginOperation(operation.id, operation?.detailedOperation?.tunneling, indexVeh)"> delete_outline </mat-icon>
                                      </div>
                                    </div>
                                  </mat-expansion-panel>
                                </mat-accordion>
                              </div>

                              <div class="add-item-dashed" *ngIf="operation && operation.id" (click)="addEnginOperation(operation)">
                                <mat-icon>add_circle_outline</mat-icon>
                                <span>{{ 'project_solutions_add_engin' | translate }}</span>
                              </div>
                            </mat-tab>
                          </mat-tab-group>
                        </div>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</div>
